import { createStyles } from "@mantine/core"
import { topNavigationFixedHeight } from "app/static/frontend/design-constants"

interface TopNavigationStyleProps {
    isInRegionSelection: boolean
    isTablet: boolean
    isMedium: boolean
    loggedInAsUser: boolean
    popdownIsOpen: boolean
}

export const useStyles = createStyles(
    (theme, { isInRegionSelection, isTablet, isMedium, loggedInAsUser, popdownIsOpen }: TopNavigationStyleProps) => ({
        topBarGroup: {
            position: "fixed",
            height: topNavigationFixedHeight,
            width: "100%",
            // This 4 is necessary to be above the Search Popdown's 3 z-index
            zIndex: 4,
            backgroundColor: theme.colors.violet[7],
            padding: "0 1rem",

            ...(loggedInAsUser && {
                backgroundColor: theme.colors.violet[2],
            }),
            ...(popdownIsOpen && {
                backgroundColor: "white",
            }),
            ...(isTablet && {
                justifyContent: "center",
            }),
            ...(isMedium &&
                popdownIsOpen && {
                    gap: ".75rem",
                }),
        },
        topBarLeft: {
            display: "flex",
            alignItems: "center",
            gap: "1.5rem",
            width: isMedium && popdownIsOpen ? "auto" : "25%",
            minWidth: isMedium && popdownIsOpen ? "auto" : "12.5rem",
            overflow: "hidden",
            ...(isTablet &&
                popdownIsOpen && {
                    display: "none",
                }),
        },
        topBarSwitchRegion: {
            ...(isMedium &&
                popdownIsOpen && {
                    display: "none",
                }),
        },
        topBarCenter: {
            display: "flex",
            justifyContent: "center",
            gap: "0.75rem",
            width: isTablet && popdownIsOpen ? "100%" : "50%",
            minWidth: !isTablet && popdownIsOpen ? "55rem" : null,
            maxWidth: popdownIsOpen ? "55rem" : "35rem",

            ...(isMedium && {
                "&&": {
                    flex: 1,
                    flexGrow: 1,
                    maxWidth: "none",
                },
            }),
        },
        topBarRight: {
            display: "flex",
            justifyContent: "end",
            width: "25%",
            minWidth: "12.5rem",

            ...(isTablet &&
                popdownIsOpen && {
                    display: "none",
                }),
            ...(isMedium &&
                popdownIsOpen && {
                    display: "none",
                }),
        },
        quorumHome: {
            height: "3.75rem",
            width: "auto",
            border: 0,

            "&:hover": {
                backgroundColor: theme.colors.violet[7],
            },

            ...(loggedInAsUser && {
                "&:hover": {
                    backgroundColor: theme.colors.violet[2],
                },
            }),

            ...(popdownIsOpen && {
                "&:hover": {
                    backgroundColor: "white",
                },
            }),

            ...(isMedium &&
                popdownIsOpen && {
                    height: "2.25rem",
                    width: "2.25rem",
                }),
        },
        quorumLogo: {
            color: "white",
            backgroundColor: theme.colors.violet[7],
            ...(loggedInAsUser && {
                color: theme.colors.violet[5],
                backgroundColor: theme.colors.violet[2],
            }),
            ...(popdownIsOpen && {
                color: theme.colors.violet[5],
                backgroundColor: "white",
            }),

            fontSize: "2.25rem",

            "&.fa-quorum-logo": {
                width: "2.25rem",
            },
        },
        regionButton: {
            padding: "8px 12px 8px 10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            border: 0,
            borderRadius: "4px",
            color: "white",
            backgroundColor: theme.colors.violet[7],
            minWidth: "fit-content",

            "&:hover": {
                backgroundColor: theme.colors.violet[9],
            },

            ...(loggedInAsUser && {
                color: theme.colors.violet[9],
                backgroundColor: theme.colors.violet[2],

                "&:hover": {
                    backgroundColor: theme.colors.violet[3],
                },
            }),

            ...(popdownIsOpen && {
                color: theme.colors.gray[9],
                backgroundColor: "white",

                "&:hover": {
                    backgroundColor: theme.colors.violet[1],
                },
            }),

            ...(isInRegionSelection && {
                color: "white",
                backgroundColor: theme.colors.violet[6],
                "&:hover": {
                    backgroundColor: theme.colors.violet[9],
                },

                ...(popdownIsOpen && {
                    color: theme.colors.gray[9],
                    backgroundColor: theme.colors.violet[1],
                    "&:hover": {
                        color: theme.colors.gray[9],
                        backgroundColor: theme.colors.violet[1],
                    },
                }),
            }),
        },
        regionButtonLabel: {
            fontSize: ".625rem",
            textTransform: "uppercase",
        },
        regionButtonName: {
            fontSize: ".875rem",
            fontWeight: 500,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: "15rem",
        },
    }),
)
